import React from 'react';
import * as Sift from '@sift/types';

import DirectoryMapping from 'pages/AttributesEdit/components/DirectoryMapping';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';

import makeStyles from '@material-ui/core/styles/makeStyles';

interface Props {
  attribute: Sift.Field;
}

function AttributeDataMapping({ attribute }: Props) {
  const classes = useStyles();
  const directoryLink = (
    <a className={classes.link} href="/admin/directories" target="_blank" rel="noopener noreferrer">
      People Data
    </a>
  );

  const subheader = (
    <>
      Data mapping enables you to populate data for this attribute from external data sources. When
      an attribute has data mapped to it, the associated people can no longer edit it. To map data
      to this attribute, go to the {directoryLink} section after saving changes in this page.
    </>
  );

  return (
    <Card className={classes.root} data-testid="attribute-data-mapping">
      <CardHeader title="Data Mapping" subheader={subheader} />
      <DirectoryMapping field={attribute} />
    </Card>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 900,
  },
  link: {
    textDecoration: 'underline',
  },
}));

export default AttributeDataMapping;
